export const QUERY_KEYS = {
  NAVIGATION: 'NAVIGATION' as const,
  SEARCH_PRODUCTS: 'SEARCH_PRODUCTS' as const,
};
